export default [
    {
        path: '/historyaccess',
        name: 'historyaccess',
        component: () => import('@/views/system/history/AccessHistory.vue'),
        meta: {},
    },
];